import React from 'react';
// import About from '../components/About/About'; 
import AboutPreview from'../components/About/AboutPreview';
import useAPI from '../hooks/useAPI';

const AboutPage = () => {
  const {
    data: teamData,
    loading,
    error,
  } = useAPI('/team');

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // const team = teamData?.data || teamData; // adjust based on API structure
  console.log("API URL:", teamData);
  return (
    <div className="pt-20">
      {/* <About data={team} /> */}
      <AboutPreview teamData={teamData} />
    </div>
  );
};

export default AboutPage;